import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { Flex } from "@chakra-ui/react";

import { isUserAuthenticated } from "redux/slices/user";
import { useAppSelector } from "redux/store";

import LoginForm from "./LoginForm";
import LoginHero from "./LoginHero";

const Login = () => {
  const isAuthenticated = useAppSelector(isUserAuthenticated);
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/back-office", { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return (
    <Flex
      minH="100vh"
      w="100vw"
      maxW="100%"
      overflow="hidden"
      bg="white"
    >
      <LoginForm />
      <LoginHero />
    </Flex>
  );
};

export default Login;
